import React from 'react';
import { Layers, Weight, DollarSign, ArrowDown } from 'lucide-react';

/**
 * Компонент секции параметров материала для 3D-печати
 */
const MaterialParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  materialTypes
}) => {
  return (
    <div className="mb-6 bg-teal-50 dark:bg-teal-900/20 p-4 rounded-lg border border-teal-100 dark:border-teal-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Layers className="w-5 h-5 mr-2 text-teal-500" />
        Параметры материала
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип материала */}
        <div>
          <label htmlFor="materialType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип материала
          </label>
          <select
            id="materialType"
            name="materialType"
            value={formData.materialType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.materialType ? 'input-error' : ''}`}
          >
            {materialTypes.map((material) => (
              <option key={material.id} value={material.id}>
                {material.name} ({material.costPerKg} ₽/кг)
              </option>
            ))}
          </select>
          {errors.materialType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.materialType}
            </p>
          )}
        </div>

        {/* Плотность материала */}
        <div>
          <label htmlFor="materialDensity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Weight className="w-4 h-4 mr-1 text-teal-500" />
            Плотность материала (г/см³)
          </label>
          <input
            type="text"
            id="materialDensity"
            name="materialDensity"
            value={formData.materialDensity}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.materialDensity ? 'input-error' : ''}`}
            placeholder="Введите плотность"
          />
          {errors.materialDensity && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.materialDensity}
            </p>
          )}
        </div>

        {/* Стоимость материала */}
        <div>
          <label htmlFor="materialCostPerKg" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <DollarSign className="w-4 h-4 mr-1 text-teal-500" />
            Стоимость материала (₽/кг)
          </label>
          <input
            type="text"
            id="materialCostPerKg"
            name="materialCostPerKg"
            value={formData.materialCostPerKg}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.materialCostPerKg ? 'input-error' : ''}`}
            placeholder="Введите стоимость"
          />
          {errors.materialCostPerKg && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.materialCostPerKg}
            </p>
          )}
        </div>

        {/* Поддержки */}
        <div>
          <div className="mb-2">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="supportsRequired"
                checked={formData.supportsRequired}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Требуются поддержки
              </span>
            </label>
          </div>
          
          {formData.supportsRequired && (
            <div>
              <label htmlFor="supportDensity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Плотность поддержек (%)
              </label>
              <input
                type="text"
                id="supportDensity"
                name="supportDensity"
                value={formData.supportDensity}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.supportDensity ? 'input-error' : ''}`}
                placeholder="Введите плотность"
              />
              {errors.supportDensity && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.supportDensity}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
      
      <div className="mt-4 bg-teal-100/50 dark:bg-teal-900/30 p-3 rounded-lg border border-teal-200 dark:border-teal-800">
        <div className="flex items-start">
          <ArrowDown className="w-5 h-5 text-teal-600 dark:text-teal-400 mr-3 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-teal-700 dark:text-teal-300 mb-1">
              Рекомендации по материалам
            </h4>
            <p className="text-xs text-teal-600 dark:text-teal-400">
              При выборе материала учитывайте не только стоимость, но и требования к готовому изделию: прочность, термостойкость, гибкость. Для функциональных деталей лучше использовать ABS, PETG или нейлон, для декоративных - PLA.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialParametersSection;